/**
 * Values conversion - convert the values the user has entered in the fields: mm = cm * 10; inches = cm / 2.54
 *
 * @param {}
 * @return {void}
 */

export const convertValues = () => {
  const $radioMeasurement = $('.js-radio-measurement');
  const $fieldMeasurement = $('.js-field-measurement');
  const $measurementLabel = $('.js-measurement-label');
  let $lastCheckedRadio = $('.js-radio-measurement:checked');

  const removeValue = ($field) => {
    $field.val('');
  }

  const checkMinMax = ($field, emptyFieldValue) => {
    const $this = $field;
    const value = $this.val() * 1
    const minValue = $this.attr('min') * 1;
    const maxValue = $this.attr('max') * 1;

    if (value > maxValue) {
      if (emptyFieldValue) {
        removeValue($this);
      }
      $this.addClass('show-hint-max').removeClass('show-hint-min').removeClass('show-hint-number');
      $this.parent().addClass('has-hint');
    } else {
      $this.removeClass('show-hint-max');
      $this.parent().removeClass('has-hint');
    }

    if (value < minValue) {
      if (emptyFieldValue) {
        removeValue($this);
      }
      $this.addClass('show-hint-min').removeClass('show-hint-max').removeClass('show-hint-number');
      $this.parent().addClass('has-hint');
    } else {
      $this.removeClass('show-hint-min');
      $this.parent().removeClass('has-hint');
    }
  }

  const convertFields = (value, lastChackedValue) => {
    $fieldMeasurement.each(function() {
      const $this = $(this);
      const placeholderValue = $this.attr('placeholder');
      const placeholderText = placeholderValue.split(' ')[0];
      const placeholderNumber = parseInt(placeholderValue.split(' ')[1]);
      const initialMin = $this.data('initialmin');
      const initialMax = $this.data('initialmax');
      let newPlaceholder = '';
      let newMin = '';
      let newMax = '';
      let hasValue = $this.val().length !== 0;
      const $hintMaxLabel = $this.parent().find('.js-hint-max');
      const $hintMinLabel = $this.parent().find('.js-hint-min');

      // Update placeholders, Minimum and Maximum for fields
      if (value == 'cm') {
        newMin = initialMin / 10;
        newMax = initialMax / 10;
        newPlaceholder = `${placeholderText} ${newMin}`;
        $hintMaxLabel.text(newMax + ' cm');
        $hintMinLabel.text(newMin + ' cm');
      }

      if (value == 'mm') {
        newMin = (initialMin);
        newMax = (initialMax);
        newPlaceholder = `${placeholderText} ${newMin}`;
        $hintMaxLabel.text(newMax + ' mm');
        $hintMinLabel.text(newMin + ' mm');
      }

      if (value == 'inches') {
        newMin = (initialMin / 25.4).toFixed(2);
        newMax = (initialMax / 25.4).toFixed(2);
        newPlaceholder = `${placeholderText} ${newMin}`;
        $hintMaxLabel.text(newMax + ' inches');
        $hintMinLabel.text(newMin + ' inches');
      }

      $this.attr('placeholder', newPlaceholder);
      $this.attr('min', newMin);
      $this.attr('max', newMax);

      // Update values for fields if present
      if (hasValue) {
        const currentValue = $this.val();
        let newValue = '';

        if (lastChackedValue == 'cm' && value == 'mm') {
          newValue = (currentValue * 10).toFixed(2);
        }

        if (lastChackedValue == 'cm' && value == 'inches') {
          newValue = (currentValue / 2.54).toFixed(2);
        }

        if (lastChackedValue == 'mm' && value == 'cm') {
          newValue = (currentValue / 10).toFixed(2);
        }

        if (lastChackedValue == 'inches' && value == 'cm') {
          newValue = (currentValue * 2.54).toFixed(2);
        }

        if (lastChackedValue == 'mm' && value == 'inches') {
          newValue = (currentValue / 25.4).toFixed(2);
        }

        if (lastChackedValue == 'inches' && value == 'mm') {
          newValue = (currentValue * 25.4).toFixed(2);
        }

        $this.val(newValue);

        checkMinMax($this, true);
      }
    });
  }

  $radioMeasurement.on('change', function(e) {
    const $this = $(this);
    const value = $this.val();

    convertFields(value, $lastCheckedRadio.val());
    $measurementLabel.text(value);
    $lastCheckedRadio = $this;
  });

  $fieldMeasurement.on('keyup', function(e) {
    const $this = $(this);

    if ($this.val().length !== 0) {
      if (!$.isNumeric($this.val())) {
        $this.addClass('show-hint-number').removeClass('show-hint-min').removeClass('show-hint-max');
        $this.parent().addClass('has-hint');
      } else {
        $this.removeClass('show-hint-number');
        $this.parent().removeClass('has-hint');
      }
    }
  });

  $fieldMeasurement.on('blur', function(e) {
    const $this = $(this);

    if ($this.val().length !== 0) {
      checkMinMax($this, true);
    }
  });
}

convertValues();
